import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

import Produto from '../../img/icon/Produto.svg'
import { Link } from 'react-router-dom';


const CardProduto = ({ id, nome, descricao, quantidadeFuncao, nomeItem, preco, duracao, empresaSelecionada }: any) => {

    const handlePaymentCreate = async (id: any, nome: any, descricao: any) => {
        try {
            const response = await api.post('pagamentos/criar', { produto_id: id, id_empresa: empresaSelecionada, nome, descricao, valor_total: Number.parseFloat(preco) })
            const pagamentoUrl = response.data.url;

            window.location.href = pagamentoUrl;
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    }

    return (
        <div className="card-produto">
            <div className="conteudo-container">
                <img className="produtoIcon" src={Produto} alt="Icon Item" />
                <div className="texto-container">
                    <div className="nome-plano">Plano Individual</div>
                    <div className="tipo-plano">{nome}</div>
                </div>
            </div>
            <p className="descricao">
                {descricao}
            </p>
            <div className="valor">{`R$${preco.toFixed(2)}`}</div>
            <div className="incluso-titulo">O que está incluso</div>
            <ul className="lista-itens">
                <li className="item">
                    <div className="check-icon"></div>
                    <span className="check-texto">{nomeItem}</span>
                </li>
                <li className="item">
                    <div className="check-icon"></div>
                    <span className="check-texto">{quantidadeFuncao} Funções</span>
                </li>
                <li className="item">
                    <div className="check-icon"></div>
                    <span className="check-texto">{duracao} Horas de Validade</span>
                </li>
            </ul>
            <button disabled className="botao-comprar">Em Uso</button>
        </div>
    );
};
export function MeusPlanos() {
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [products, setProducts] = useState([]);
    const [licensa, setLicensa] = useState<any>({});

    const calcularPreco = (quantidadeFuncao: number, precoPorFuncao: number, precoBase: number) => {
        const precoTotal = quantidadeFuncao * precoPorFuncao + precoBase;
        return `R$${precoTotal.toFixed(2)}`;
    }

    const loadProducts = async () => {
        try {
            const response = await api.get('produtos')
            setProducts(response.data);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    }

    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : 0);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const loadLicensas = async () => {
        try {
            const response = await api.get('licencas/detalhar/' + selectedCompany);
            setLicensa(response.data);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        loadProducts();
        loadCompanies();
    }, []);

    useEffect(() => {
        if (selectedCompany !== 0) {
            loadLicensas();
        }
    }, [selectedCompany]);

    const handleSelectCompany = (id: any) => {
        if (id !== selectedCompany) {

            setSelectedCompany(id);
    
            setIsLoading(true);
            console.log("Detalhando licensas")
            loadLicensas()
            console.log(licensa)
        }
    }

    const handlePaymentCreate = async (id: any) => {
        try {
            const response = await api.post('pagamentos/criar', { produto_id: id, id_empresa: selectedCompany, change: true})
            const pagamentoUrl = response.data.url;

            window.location.href = pagamentoUrl;
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <div className='d-flex align-items-center' style={{ width: '100%' }}>
                        <Text text="Empresa" />
                        <Select width="600px" id='empresas' onSelect={handleSelectCompany}>
                            {companies.map((company: any, index: any) => (
                                <Options key={company.id} value={company.id} name={company.nome} selected={index === 0} />
                            ))}
                        </Select>
                    </div>
                </CardContent>
                <CardContent>
                    <div className='conteudo'>

                        {licensa.produto ? (
                            <>
                                <div className="half-screen-1">
                                    <Title text="Planos em Uso" />
                                    <CardProduto
                                        key={licensa.produto.id}
                                        id={licensa.produto.id}
                                        quantidadeFuncao={licensa.produto.quantidade}
                                        descricao={licensa.produto.descricao}
                                        nome={licensa.produto.nome}
                                        nomeItem={licensa.produto.nome_item}
                                        preco={licensa.produto.preco}
                                        duracao={licensa.produto.duracao}
                                        empresaSelecionada={selectedCompany}
                                    />

                                </div>
                                <div className="half-screen-2">

                                    {licensa.upgrade[0]?.id ? (
                                        <>
                                            {licensa.upgrade.map((upgrade: any) => (
                                                <div className="card-upgrades">
                                                    <div className="card-rectangle">
                                                        <h2 className="card-title">
                                                            <span className="bold card-price">{upgrade.nome}</span><span className='gray'>Plano Individual</span>
                                                        </h2>
                                                        <p className="card-description">
                                                            Descrição do plano: {upgrade.descricao}
                                                            <br/>
                                                            Número de funções: {upgrade.quantidade}
                                                        </p>
                                                        <br />
                                                        <div className="card-price">
                                                            <span className="bold">{calcularPreco(upgrade.quantidade, upgrade.preco_por_funcao, upgrade.preco_base_item)}</span>
                                                        </div>
                                                        <button  onClick={() => handlePaymentCreate(upgrade.id)} className="trocar-button">Trocar</button>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        <p style={{ display: 'inline' }}>
                                            Sem possibilidades de upgrade de plano.
                                            O seu plano é o mais completo que possuímos no momento, para um plano customizado entre em contato: 

                                            <Link to="/planos" style={{ textDecoration: 'none' }}>
                                                <span style={{ color: '#0575E6', whiteSpace: 'nowrap' }}> CLICK AQUI</span>
                                            </Link>
                                        </p>
                                    )}

                                </div>
                            </>
                        ) : (
                            <div>
                                <p style={{ display: 'inline' }}>
                                    Você não possui nenhum plano ativo para essa empresa.
                                    Para ir para a página de planos

                                    <Link to="/planos" style={{ textDecoration: 'none' }}>
                                        <span style={{ color: '#0575E6', whiteSpace: 'nowrap' }}> CLICK AQUI</span>
                                    </Link>
                                </p>
                            </div>
                        )}
                    </div>
                </CardContent>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}